<script setup lang="ts">
import { useLoadingState } from '@/loading';
import { useNotificationPolling } from '@/utils/useNotificationPolling';
import { faBell } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon, TmlBubble, TmlPip } from '@teemill/components';
import { useNotificationsStore } from '@teemill/modules/notifications';
import { whenever } from '@vueuse/core';
import { ref, watch } from 'vue';

const { loaded } = useLoadingState();

const polling = useNotificationPolling();
whenever(loaded, () => polling?.start(), { immediate: true });

const notificationsStore = useNotificationsStore();

const addShake = ref(false);

watch(
  () => notificationsStore.unreadCount,
  (value, oldValue) => {
    if (value > oldValue) {
      if (addShake.value === false) {
        addShake.value = true;
        setTimeout(() => {
          addShake.value = false;
        }, 12000);
      }
    }
  },
);
</script>

<template>
  <TmlPip>
    <template v-if="notificationsStore.unreadCount > 0" #pip>{{
      notificationsStore.unreadCount
    }}</template>
    <TmlBubble>
      <FontAwesomeIcon
        :icon="faBell"
        :class="{ 'fa-shake': addShake }"
        style="--fa-animation-duration: 4s; --fa-animation-iteration-count: 3"
      />
    </TmlBubble>
  </TmlPip>
</template>
